import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Defers unmounting of a modal component until the close animation completes.
 * Returns [shouldRender, onCloseAnimationEnd]:
 * - shouldRender: whether the component should render its content
 * - onCloseAnimationEnd: callback to pass to Modal/ModalBase's onCloseAnimationEnd prop
 */
export function useDeferredClose(isOpen: boolean): [boolean, () => void] {
    const [shouldRender, setShouldRender] = useState(isOpen);
    const isOpenRef = useRef(isOpen);
    isOpenRef.current = isOpen;

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
        }
    }, [isOpen]);

    const onCloseAnimationEnd = useCallback(() => {
        if (!isOpenRef.current) {
            setShouldRender(false);
        }
    }, []);

    return [shouldRender, onCloseAnimationEnd];
}
